var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBoxDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6668 22.3519V10.6667L16.0002 13.3334L5.3335 10.6667V22.3519C5.3335 23.362 5.90417 24.2854 6.80759 24.7371L14.8076 28.7371C15.5583 29.1124 16.442 29.1124 17.1927 28.7371L25.1927 24.7371C26.0962 24.2854 26.6668 23.362 26.6668 22.3519Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6668 8.00002L17.1927 3.26297C16.442 2.8876 15.5583 2.8876 14.8076 3.26297L5.3335 8.00002L16.0002 13.3334L26.6668 8.00002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 8L16 13.3333L18.6667 17.3333L29.3333 12L26.6667 8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8L16 13.3333L13.3333 17.3333L2.66667 12L5.33333 8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6585 1.91412C21.0742 2.27781 21.1163 2.90957 20.7526 3.32521L16.9261 7.6984C16.1038 8.63812 14.6875 8.76395 13.7124 7.98391L11.3753 6.11424C10.9441 5.76923 10.8742 5.13993 11.2192 4.70867C11.5642 4.27741 12.1935 4.20749 12.6247 4.5525L14.9618 6.42217C15.1011 6.53361 15.3035 6.51563 15.4209 6.38139L19.2475 2.0082C19.6111 1.59256 20.2429 1.55044 20.6585 1.91412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBoxDone);
export default __webpack_public_path__ + "static/media/open_box-done.94d320417c9c93f45b842f37bdf38758.svg";
export { ForwardRef as ReactComponent };